import * as React from 'react';

import classNames from 'classnames';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/author-common';

import 'css!./__styles__/CharacterCount';

type Props = {
  count: number;
  limit: number;
};

const CharacterCount = (props: Props) => {
  const { count, limit } = props;

  const classes = classNames('rc-CharacterCount', {
    error: count > limit,
  });

  return (
    <Typography2 component="p" variant="bodySecondary" className={classes}>
      {_t(`#{count}/#{limit} characters`, { count, limit })}
    </Typography2>
  );
};

export default CharacterCount;
